import React from 'react';

export const ManagerIcon = (props) => (
    <svg className="h-6 w-6 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.125A2.25 2.25 0 014.5 4.875h15A2.25 2.25 0 0121.75 7.125v1.563a2.25 2.25 0 01-2.25 2.25H4.5A2.25 2.25 0 012.25 8.688V7.125zM2.25 15.125A2.25 2.25 0 014.5 12.875h15A2.25 2.25 0 0121.75 15.125v1.563a2.25 2.25 0 01-2.25 2.25H4.5A2.25 2.25 0 012.25 16.688V15.125z" />
    </svg>
);

export default ManagerIcon;